import React, { ReactNode, useRef, useState } from 'react'
import NativeSlider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { IClinique } from 'components/core/types'
import CliniquesSliderNav from 'components/ui/CliniquesSliderNav'

interface SliderProps {
  children: ReactNode,
  cliniques: IClinique[],
  onBeforeChange?: (currentValue, newValue) => void,
  paddingLeft?: number,
}

const Slider = ({
  children,
  cliniques,
  onBeforeChange,
  paddingLeft,
}: SliderProps) => {
  const sliderRef = useRef<NativeSlider>()
  const [activeSlide, setActiveSlide] = useState(0)
  const responsive = [
    {
      breakpoint: 640,
      settings: {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1536,
      settings: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1920,
      settings: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
  ]

  const handlePrev = () => {
    sliderRef.current.slickPrev()
  }
  const handleNext = () => {
    sliderRef.current.slickNext()
  }
  const handleGoTo = (i) => {
    sliderRef.current.slickGoTo(i)
  }

  const handleBeforeChange = (current, next) => {
    setActiveSlide(next)
    onBeforeChange(current, next)
  }

  return (
    <>
      <NativeSlider
        speed={500}
        responsive={responsive}
        slidesToShow={5}
        slidesToScroll={1}
        className="react-appointment-slider"
        pauseOnFocus={false}
        pauseOnHover={false}
        infinite={false}
        autoplay={false}
        arrows={false}
        dots={false}
        autoplaySpeed={7000}
        variableWidth
        swipeToSlide
        beforeChange={handleBeforeChange}
        ref={(slider) => {
          sliderRef.current = slider
        }}
      >
        {children}
      </NativeSlider>
      {cliniques.length > 1 && (
        <CliniquesSliderNav
          activeSlide={activeSlide}
          cliniques={cliniques}
          paddingLeft={paddingLeft}
          next={handleNext}
          prev={handlePrev}
          goto={handleGoTo}
        />
      )}
    </>
  )
}
Slider.defaultProps = {
  onBeforeChange: () => null,
  paddingLeft: null,
}
export default Slider
